<template>
  <div class="roles-grid">
    <Card v-for="{ id, ...rest } in productRoles" :key="id" dis-hover>
      <Role v-bind="{ id, ...rest }" edit />
    </Card>
  </div>
</template>

<script>
import Role from "@/Users/OnboardUser/components/OrganizationStep/components/OrganizationInformation/components/Role/Role.vue";

export default {
  components: { Role },
  inject: ["organization"],
  computed: {
    productRoles: ({ organization: { roles } }) =>
      roles.filter(({ name }) => name !== "switcher")
  }
};
</script>

<style scoped>
.roles-grid {
  @apply py-6 px-20;
  display: grid;
  grid-template-columns: repeat(auto-fill, 320px);
  grid-gap: 2rem;
  justify-content: space-between;
}
</style>
